$(document).ready(function () {
  // $(".tab-nav span").on("click", function () {
  //   $([$(this).parent()[0], $($(this).data("href"))[0]])
  //     .addClass("active")
  //     .siblings(".active")
  //     .removeClass("active");
  // });
 
  
});
